/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

import { BehaviorSubject, Subject } from "rxjs";
import { LoginComponent } from "../app/pages/login/login.component";

//API: 'http://192.168.25.6:8086/api/'
//  API: 'https://localhost:44369/api'

// let ambienteAPI = LoginService.Ambiente


export class environment{

  static API = 'https://backendcrm.sistemasfocuscontabil.com/api/'
  static APIRelatorio = "";
  static ambiente = '';
  static production = true;
  static emitAPI = new BehaviorSubject<any>(environment.API)
  static Site = 'http://192.168.25.6:8099'
  static Chat = 'https://7tfs7x4t-7001.brs.devtunnels.ms'
  constructor(){

  }

  static emitir(ambiente?){
    console.log(ambiente)
    if(environment.production){

      environment.APIRelatorio = "https://crmfocusreports.sistemasfocuscontabil.com/api/"

      if(ambiente == "CRMFocus"){
        environment.ambiente = 'CRMFocus'
        environment.emitAPI.next('https://backendcrm.sistemasfocuscontabil.com/api/')
        environment.Site = ('https://crmfocus.sistemasfocuscontabil.com')
        environment.Chat = ('https://wpp.sistemasfocuscontabil.com')
      }
      if(ambiente == "CRM_ADCCont"){
        environment.ambiente = 'CRM_ADCCont'
        environment.emitAPI.next('https://backendcrm.sistemasfocuscontabil.com/api/')
        environment.Site = ('https://crmfocus.sistemasfocuscontabil.com')
        environment.Chat = ('https://wpp.sistemasfocuscontabil.com')
      }
        //https://wfwn04m7-7001.brs.devtunnels.ms
    } else {

      // let api = 'https://localhost:44369/api/'
      //Tunel máquina do jorbe
      // let api = 'https://wfwn04m7-44369.brs.devtunnels.ms/api/'
      let api = 'http://192.168.25.6:8010/api/'
      let apiRelatorio = "http://192.168.25.6:8001/api/"
      //let apiRelatorio = 'https://localhost:44359/api/'

      environment.emitAPI.next(api)
      environment.API = api
      environment.APIRelatorio = apiRelatorio
      environment.ambiente = "CRMFocus"
    }

  }


  // ALTERAR AMBIENTE E BOOLEANO AO BUILDAR PARA PUBLICACAO DESEJADA
  Homologacao = false
  Ambiente: 'Produção'
  //Ambiente: 'Produ��o'
}


//  // API: 'http://192.168.25.6:8086/api/',
//   //API: 'http://192.168.25.6:8091/api/',

//   // API: 'https://backendcrm.sistemasfocuscontabil.com/homologacao/api/',
//   API: 'https://backendcrm.sistemasfocuscontabil.com/api/',
//   //API: 'https://localhost:44369/api/'
